module.exports = __webpack_public_path__ + "img/personnel.9d40756a.jpg";